export enum TranscriptPromptType {
    ISSUE_TITLE = "title",
    ISSUE_DESCRIPTION = "description",
    ISSUE_DESCRIPTION_APPEND = "appendDescription",
    GROUP_LOCATION_NAME = "location"
}